/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotSecure/view.blocks to change it.
import LockOpenIcon from 'DesignSystem/Svgs/LockOpenIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NotSecure({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/Secure/InApp/SecureIndicator/NotSecure"
  
}) {
  return (<React.Fragment
>
<LockOpenIcon
  viewPath={`${viewPath}/LockOpenIcon`}
 width={16}
 height={16}
 stroke="#474747"
/>
{children}
</React.Fragment>)
}